// extracted by mini-css-extract-plugin
export default {"recommend":"index_recommend_STobg","recommendTitle":"index_recommendTitle_f7PcF","recommendBox":"index_recommendBox_i45WI"};